import * as React from "react";
import {
  Grid,
  TextField,
  Typography,
  useTheme,
  Popper,
  Paper,
  Button,
  ClickAwayListener,
  Box,
} from "@mui/material";

import { format, isValid } from "date-fns";
import { AppContext } from "../../contextProviders/AppContext";
import { translation } from "../Dictionary";
import { Stack } from "@mui/system";

export default function FixedReturnTimePickerComponent({
  title,
  onChange,
  hasError,
  selectedTimeFrame,
  type,
  fixedTimeFrames,
  handleSelectedTimeFrame,
  setSelectedPicker,
  selectedPicker,
  startTime,
  endTimeOk,
  endTime,
  mobileViewPort,
  contentHeigth,
}) {
  const theme = useTheme();
  const {
    locale,
    language,
    setReservationReturn,
    setReservationStart,
    handleActiveStep,
    setInitSearch,
  } = React.useContext(AppContext);

  const handleAdvance = () => {
    setSelectedPicker(null);
    setInitSearch(true);
    // dateChanged(startTime, endTime);
  };

  function FixedTimeFrameSelect({ value, selectedTimeFrame, indexValue }) {
    return (
      <Grid
        item
        container
        style={{
          justifyContent: "center",
          alignItems: "center",
          borderStyle: "solid",
          width: 45,
          height: 45,
          padding: 5,
          margin: 5,
          borderWidth: selectedTimeFrame === value ? 4 : 2,
          borderColor:
            selectedTimeFrame === value
              ? theme.palette.primary.main
              : "lightgrey",
          borderRadius: "50%",
          cursor: "pointer",
        }}
        onClick={() => handleSelectedTimeFrame(value, indexValue)}
      >
        <Typography variant="body1">{value}h</Typography>
      </Grid>
    );
  }

  const [anchorPopper, setAnchorPopper] = React.useState(null);

  const ref = React.useRef(null);

  React.useEffect(() => {
    setAnchorPopper(ref.current);
  }, []);

  return (
    <Box>
      <Box
        ref={ref}
        onClick={() => setSelectedPicker("returnTime")}
        sx={{
          height: contentHeigth,
          display: "flex",
          borderRadius: "10px",
          bgcolor: selectedPicker === type ? "white" : "transparent",
          boxShadow: selectedPicker === type ? theme.shadows[2] : "transparent",
          justifyContent: "center",
          alignItems: "center",
          transition: "ease-in-out 250ms",
          alignItems: "center",
          justifyContent: "center",
          borderStyle: "solid",
          borderWidth: 2,
          borderColor:
            isValid(endTime) && hasError
              ? theme.palette.warning.main
              : "transparent",
          cursor: "pointer",
          "&:hover": {
            boxShadow: theme.shadows[2],
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            color: theme.palette.primary.mainText,
          }}
        >
          <Typography>
            {endTimeOk.errorComponent === type && endTimeOk.hasError
              ? translation.get(language, "Timepicker closed error")
              : hasError
              ? translation.get(language, "Check times label")
              : translation.get(language, "Return time text")}
          </Typography>
          <Typography>
            {" "}
            {isValid(endTime)
              ? format(new Date(endTime), "HH:mm", {
                  locale: locale,
                })
              : ""}
          </Typography>
        </Box>
      </Box>
      <Popper
        id={"textIdPopper"}
        open={selectedPicker === "returnTime"}
        anchorEl={anchorPopper}
        placement="bottom"
        /*   onBlur={() => setOpen(false)} */
        sx={{
          width: mobileViewPort ? "95vw" : "350px",
          zIndex: 1000,
          offset: "25px",
        }}
      >
        <ClickAwayListener onClickAway={() => setSelectedPicker(null)}>
          <Paper
            elevation={3}
            sx={{
              borderRadius: "20px",
              paddingTop: "20px",
              width: "300px",
              marginTop: "7px",
            }}
          >
            <Box>
              <Typography
                variant="body2"
                align="center"
                sx={{ fontSize: "16px", textTransform: "uppercase" }}
              >
                {endTimeOk.hasError
                  ? endTimeOk.message
                  : hasError
                  ? translation.get(language, "Check times label")
                  : translation.get(language, "Timepicker return title")}
              </Typography>

              <Typography
                sx={{
                  marginLeft: "25px",
                  fontSize: "3rem",
                  fontFamily:
                    " -apple-system,BlinkMacSystemFont,Roboto,Sofia Pro,sans-serif",
                  fontWeight: 400,
                  lineHeight: 1.167,
                }}
              >
                {isValid(endTime)
                  ? format(endTime, "HH:mm", {
                      locale: locale,
                    })
                  : ""}
              </Typography>

              <Box
                sx={{
                  margin: "10px",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Typography
                  align="center"
                  variant="body2"
                  style={{
                    color: theme.palette.primary.mainText,
                    fontSize: 20,
                    marginBottom: 10,
                    marginTop: 15,
                  }}
                >
                  {translation.get(language, "Select duration label")}
                </Typography>

                <Stack
                  direction="row"
                  style={{
                    justifyContent: "space-evenly",
                  }}
                >
                  {fixedTimeFrames.map((item, index) => {
                    return (
                      <FixedTimeFrameSelect
                        key={item + index}
                        value={item}
                        selectedTimeFrame={selectedTimeFrame}
                        indexValue={index}
                      />
                    );
                  })}
                </Stack>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  paddingBottom: "7px",
                }}
              >
                <Button
                  variant="contained"
                  onClick={() => handleAdvance()}
                  sx={{
                    marginRight: "5px",
                    height: "40px",
                    borderBottomRightRadius: "20px",
                    borderTopRightRadius: "20px",
                    // borderRadius: "20px",
                    width: "95px",
                  }}
                  disabled={hasError}
                >
                  {translation.get(language, "Search label")}
                </Button>
              </Box>
            </Box>
          </Paper>
        </ClickAwayListener>
      </Popper>
    </Box>
  );
}
